<template>
  <div class="admin-project-create">
    <div class="title">
      <b style="font-size: 25px">创建新项目</b>
    </div>
    <TakoPanel :header="false" style="padding: 10px 20px; background: white">
      <el-form
        style="padding-top: 20px"
        label-width="120px"
        :model="formData"
        :rules="rules"
        ref="formRef"
      >
        <el-form-item label="项目名称:" prop="inputProjectName" class="line">
          <el-input
            v-model="formData.inputProjectName"
            class="Input"
            placeholder="给项目起个名字"
          />
        </el-form-item>
        <el-form-item label="包名:" prop="inputPackageName" class="line">
          <el-input
            v-model="formData.inputPackageName"
            class="Input"
            placeholder="请指定包名"
          />
        </el-form-item>
        <el-form-item label="打包服务:" class="line" prop="inputPacking">
          <el-radio v-model="formData.inputPacking" :label="true">是</el-radio>
          <el-radio v-model="formData.inputPacking" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="地区:" prop="inputRegion" class="line">
          <el-select
            v-model="formData.inputRegion"
            prop="region"
            class="Input"
            clearable
            placeholder="请选择地区"
            style="width: 100%"
          >
            <el-option
              v-for="item in region"
              :label="item.label"
              :key="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="制作人:" prop="inputProducer" class="line">
          <el-input
            v-model="formData.inputProducer"
            class="Input"
            clearable
            placeholder="请指定制作人"
          />
        </el-form-item>
        <el-form-item label="主程:" prop="inputProgramer" class="line">
          <el-input
            v-model="formData.inputProgramer"
            class="Input"
            clearable
            placeholder="请添加主程"
          />
        </el-form-item>
        <el-form-item
          label="项目负责人:"
          prop="inputPersonInCharge"
          class="line"
        >
          <el-input
            v-model="formData.inputPersonInCharge"
            class="Input"
            clearable
            placeholder="请指定负责人"
          />
        </el-form-item>
        <el-form-item label="管理员:" prop="inputAdmin" class="line">
          <el-select
            class="Input"
            style="text-align: left; width: 100%"
            v-model="formData.inputAdmin"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请添加管理员"
          >
            <el-option
              v-for="item in admin"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="inputRemark" class="line">
          <el-input
            v-model="formData.inputRemark"
            class="Input"
            placeholder="添加备注信息"
            type="textarea"
            :rows="3"
            style="vertical-align: top; margin-top: -5px"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <div class="line">
          <el-button style="width: 300px" type="primary" @click="handleCreate">
            确定
          </el-button>
          <router-link
            :to="{
              name: 'AdminProjects',
              query: { project: currentProjectId },
            }"
          >
            <el-button style="margin-left: 30px">返回</el-button>
          </router-link>
        </div>
      </div>
    </TakoPanel>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import {
  apiCreateCertificate,
  apiGetKoaUserList,
  apiGetProjects,
} from "@/Api/AppApi";
import TakoPanel from "@/Components/TakoPanel.vue";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const $confirm = appContext.config.globalProperties.$confirm;

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);

const router = useRouter();

const rules = {
  inputProjectName: [
    { required: true, message: "请输入项目名称", trigger: "blur" },
  ],
  inputPackageName: [
    { required: true, message: "请输入包名", trigger: "blur" },
  ],
  // inputRegion: [
  //   {required: true, message: '请选择区域', trigger: 'change'}
  // ],
  // inputProducer: [
  //   {required: true, message: '请指定制作人', trigger: 'blur'}
  // ],
  // inputPersonInCharge: [
  //   {required: true, message: '请添加主程', trigger: 'blur'}
  // ],
  // inputProgramer: [
  //   {required: true, message: '请指定负责人', trigger: 'blur'}
  // ],
  inputAdmin: [{ required: true, message: "请添加管理员", trigger: "change" }],
};
const region = [
  {
    name: "珠海",
    label: "珠海",
  },
  {
    name: "北京",
    label: "北京",
  },
  {
    name: "成都",
    label: "成都",
  },
  {
    name: "大连",
    label: "大连",
  },
  {
    name: "广州",
    label: "广州",
  },
];

const admin = ref([]);
onMounted(async () => {
  const res = await apiGetKoaUserList();
  if (res.code === 0) {
    admin.value = res.data || [];
  } else {
    $message.error(res.message);
  }
});

const formRef = ref(null);
const formData = reactive({
  inputProjectName: "",
  inputRegion: "",
  inputPackageName: "",
  inputPacking: false,
  inputRemark: "",
  inputProducer: "",
  inputProgramer: "", //主程
  inputPersonInCharge: "", //负责人
  inputAdmin: [],
});
async function handleCreate() {
  try {
    await $confirm("您确定创建此项目?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    });
    formRef.value.validate(async (valid) => {
      if (valid) {
        const postData = {
          name: formData.inputProjectName,
          region: formData.inputRegion,
          packagename: formData.inputPackageName,
          packing: formData.inputPacking.toString(),
          remark: formData.inputRemark,
          producer: formData.inputProducer,
          programer: formData.inputProgramer, //主程
          personincharge: formData.inputPersonInCharge, //负责人
          admins: formData.inputAdmin,
        };
        const res = await apiCreateCertificate(postData);
        if (res.code === 0) {
          const resp = await apiGetProjects();
          if (resp.code === 0) {
            projectStore.updateProjectList(resp.data);
            $message.success("创建成功");
            router.push({
              name: "AdminProjects",
              query: { project: currentProjectId.value },
            });
          } else {
            $message.error(resp.message);
          }
        } else {
          $message.error(res.message);
          return;
        }
      }
    });
  } catch (e) {
    // nothing
  }
}
</script>
<style lang="scss" scoped>
.admin-project-create {
  padding: 20px;
}

.title {
  text-align: left;
  margin-bottom: 20px;
  margin-left: 12px;
}

.line {
  width: 600px;
}
</style>
